import { type FunctionComponent, type SVGProps } from 'react';

import { ReactComponent as AppointmentManagementIcon } from './assets/useCases/AppointmentManagement.svg';
import { ReactComponent as CareGapClosureIcon } from './assets/useCases/CareGapClosure.svg';
import { ReactComponent as ChartReviewIcon } from './assets/useCases/ChartReview.svg';
import { ReactComponent as ClinicalInformationCollectionIcon } from './assets/useCases/ClinicalInformationCollection.svg';
import { ReactComponent as CoordinationOfCareIcon } from './assets/useCases/CoordinationOfCare.svg';
import { ReactComponent as DenialManagementIcon } from './assets/useCases/DenialManagement.svg';
import { ReactComponent as DocumentProcessingIcon } from './assets/useCases/DocumentProcessing.svg';
import { ReactComponent as HCCIcon } from './assets/useCases/HCC.svg';
import { ReactComponent as InboundCallDeflectionIcon } from './assets/useCases/InboundCallDeflection.svg';
import { ReactComponent as OtherIcon } from './assets/useCases/Other.svg';
import { ReactComponent as PatientCommunicationIcon } from './assets/useCases/PatientCommunication.svg';
import { ReactComponent as PaymentCollectionIcon } from './assets/useCases/PaymentCollection.svg';
import { ReactComponent as PriorAuthorizationAndNOAIcon } from './assets/useCases/PriorAuthorizationAndNOA.svg';
import { ReactComponent as RegistrationAndIntakeIcon } from './assets/useCases/RegistrationAndIntake.svg';
import { ReactComponent as SchedulingIcon } from './assets/useCases/Scheduling.svg';

enum UseCase {
  AppointmentManagement = 'AppointmentManagement',
  CareGapClosure = 'CareGapClosure',
  ChartReview = 'ChartReview',
  ClinicalInformationCollection = 'ClinicalInformationCollection',
  CoordinationOfCare = 'CoordinationOfCare',
  DenialManagement = 'DenialManagement',
  DocumentIndexing = 'DocumentIndexing',
  DocumentOrderTranscription = 'DocumentOrderTranscription',
  DocumentProcessing = 'DocumentProcessing',
  DocumentSorting = 'DocumentSorting',
  Hcc = 'HCC',
  InboundCallDeflection = 'InboundCallDeflection',
  NoticeOfAdmission = 'NoticeOfAdmission',
  PatientCommunication = 'PatientCommunication',
  PaymentCollection = 'PaymentCollection',
  PriorAuthorization = 'PriorAuthorization',
  PriorAuthorizationAndNOA = 'PriorAuthorizationAndNOA',
  RegistrationAndIntake = 'RegistrationAndIntake',
  Scheduling = 'Scheduling',
  Other = 'Other',
}

export function isKnownFlowTemplateCardUseCase(useCase: string): useCase is UseCase {
  return useCase in FlowTemplateCardUseCaseSvgIconMap;
}

export const FlowTemplateCardUseCaseSvgIconMap: Record<
  UseCase,
  FunctionComponent<
    SVGProps<SVGSVGElement> & {
      title?: string;
    }
  >
> = {
  [UseCase.AppointmentManagement]: AppointmentManagementIcon,
  [UseCase.CareGapClosure]: CareGapClosureIcon,
  [UseCase.ChartReview]: ChartReviewIcon,
  [UseCase.ClinicalInformationCollection]: ClinicalInformationCollectionIcon,
  [UseCase.CoordinationOfCare]: CoordinationOfCareIcon,
  [UseCase.DenialManagement]: DenialManagementIcon,
  [UseCase.DocumentIndexing]: DocumentProcessingIcon,
  [UseCase.DocumentOrderTranscription]: DocumentProcessingIcon,
  [UseCase.DocumentProcessing]: DocumentProcessingIcon,
  [UseCase.DocumentSorting]: DocumentProcessingIcon,
  [UseCase.Hcc]: HCCIcon,
  [UseCase.InboundCallDeflection]: InboundCallDeflectionIcon,
  [UseCase.NoticeOfAdmission]: PriorAuthorizationAndNOAIcon,
  [UseCase.PatientCommunication]: PatientCommunicationIcon,
  [UseCase.PaymentCollection]: PaymentCollectionIcon,
  [UseCase.PriorAuthorization]: PriorAuthorizationAndNOAIcon,
  [UseCase.PriorAuthorizationAndNOA]: PriorAuthorizationAndNOAIcon,
  [UseCase.RegistrationAndIntake]: RegistrationAndIntakeIcon,
  [UseCase.Scheduling]: SchedulingIcon,
  [UseCase.Other]: OtherIcon,
};
